import React from 'react';

const Brochure = () => {
  const downloadBrochure = () => {
    const brochureContent = `
<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <title>ENESSA FOODS - Company Brochure</title>
    <style>
        body { font-family: Arial, sans-serif; margin: 0; padding: 20px; background: #f8f9fa; }
        .brochure { max-width: 800px; margin: 0 auto; background: white; border-radius: 15px; overflow: hidden; box-shadow: 0 10px 30px rgba(0,0,0,0.1); }
        .header { background: linear-gradient(135deg, #e74c3c, #c0392b); color: white; padding: 40px; text-align: center; }
        .logo { font-size: 48px; font-weight: bold; margin-bottom: 10px; }
        .tagline { font-size: 18px; opacity: 0.9; }
        .section { padding: 30px; }
        .section h2 { color: #2c3e50; border-bottom: 3px solid #e74c3c; padding-bottom: 10px; margin-bottom: 20px; }
        .stats { display: flex; justify-content: space-around; background: #f8f9fa; padding: 20px; margin: 20px 0; border-radius: 10px; }
        .stat { text-align: center; }
        .stat-number { font-size: 32px; font-weight: bold; color: #e74c3c; }
        .services { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin: 20px 0; }
        .service { background: #f8f9fa; padding: 20px; border-radius: 10px; border-left: 4px solid #e74c3c; }
        .contact { background: #2c3e50; color: white; padding: 30px; text-align: center; }
        .contact h2 { color: white; border-bottom-color: #e74c3c; }
    </style>
</head>
<body>
    <div class="brochure">
        <div class="header">
            <div class="logo">ENESSA FOODS</div>
            <div class="tagline">Premium Bakery Raw Materials & Solutions</div>
        </div>
        
        <div class="section">
            <h2>About Us</h2>
            <p>Enessa Foods is a leading provider of bakery raw materials and solutions in India. With years of experience and deep industry knowledge, we serve bakeries of all sizes - from artisan operations to large-scale production facilities.</p>
            
            <div class="stats">
                <div class="stat">
                    <div class="stat-number">500+</div>
                    <div>Bakeries Served</div>
                </div>
                <div class="stat">
                    <div class="stat-number">20+</div>
                    <div>Custom Formulations</div>
                </div>
                <div class="stat">
                    <div class="stat-number">25%</div>
                    <div>Cost Savings</div>
                </div>
                <div class="stat">
                    <div class="stat-number">90%</div>
                    <div>Client Retention</div>
                </div>
            </div>
        </div>
        
        <div class="section">
            <h2>Our Services</h2>
            <div class="services">
                <div class="service">
                    <h3>Custom Formulations</h3>
                    <p>Tailored ingredient solutions for your specific production needs.</p>
                </div>
                <div class="service">
                    <h3>Recipe Development</h3>
                    <p>Professional recipe creation and optimization services.</p>
                </div>
                <div class="service">
                    <h3>Technical Support</h3>
                    <p>24/7 expert guidance and process optimization.</p>
                </div>
                <div class="service">
                    <h3>Quality Assurance</h3>
                    <p>Rigorous quality control and consistency standards.</p>
                </div>
            </div>
        </div>
        
        <div class="section">
            <h2>Our Products</h2>
            <ul style="columns: 2; column-gap: 30px;">
                <li>Bread Improvers</li>
                <li>Cake Premixes</li>
                <li>GRR Gluten Replacers</li>
                <li>Clean Label Solutions</li>
                <li>Specialty Ingredients</li>
                <li>Preservation Systems</li>
                <li>Natural Emulsifiers</li>
                <li>Enzyme Systems</li>
            </ul>
        </div>
        
        <div class="section">
            <h2>Why Choose Enessa Foods?</h2>
            <ul>
                <li><strong>Global Expertise:</strong> Deep industry knowledge with international standards</li>
                <li><strong>Trusted Partner:</strong> Established name in the Indian baking industry</li>
                <li><strong>Scalable Solutions:</strong> Serving artisan bakeries to large-scale operations</li>
                <li><strong>Innovation Focus:</strong> Cutting-edge R&D and sustainable practices</li>
                <li><strong>Cost Effective:</strong> Competitive pricing with quality assurance</li>
            </ul>
        </div>
        
        <div class="contact">
            <h2>Contact Us</h2>
            <p><strong>Address:</strong><br>
            Office No. 204, M.M. Palace,<br>
            Kondhwa Khurd, Pune, Maharashtra, India<br>
            PIN Code: 411048</p>
            
            <p><strong>Phone:</strong> +91 9823107666 / +91 9823108666</p>
            <p><strong>Email:</strong> contact@enessafoods.com</p>
            
            <p style="margin-top: 30px; font-size: 18px;">
                <strong>Ready to elevate your baking?</strong><br>
                Contact us today for customized solutions!
            </p>
        </div>
    </div>
</body>
</html>`;

    const blob = new Blob([brochureContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Enessa-Foods-Brochure.html';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return { downloadBrochure };
};

export default Brochure;